import { Component } from 'react'
import * as styles from 'components/features/pfm/PeergroupMenuPopup/PeergroupMenuPopup.styl'
import { Member } from 'interfaces/member'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { BasicBlockCorners } from 'interfaces/component'
import { DEFAULT_PROP_VALUE } from 'constants/peergroups'
import { shortenMoney, formatAreaType, formatHousingType } from 'helpers/formatHelpers'
import { getCityStateLabel } from 'helpers/cityHelpers'
import { SidebarPopup } from 'components/features/pfm/SidebarPopup/SidebarPopup'
import { SidebarPopupBackButton } from 'components/features/pfm/SidebarPopup/SidebarPopupBackButton'
import { PeerDefinition } from 'components/features/pfm/PeerDefinition/PeerDefinition'
import { SidebarPopupHeader } from 'components/features/pfm/SidebarPopup/SidebarPopupHeader'

export type PeergroupMenuMemberPopupStateProps = {
  member: Member
  hideTimeoutId: number | null
}

export type PeergroupMenuMemberPopupDispatchProps = {
  onHidePopup: () => void
  onRegisterHideTimeout: (timeoutId: number) => void
}

export type PeergroupMenuMemberPopupOwnProps = {
  corners: BasicBlockCorners
  onBackButtonClick?: () => void
}

type PeergroupMenuMemberPopupProps =
  & PeergroupMenuMemberPopupStateProps
  & PeergroupMenuMemberPopupDispatchProps
  & PeergroupMenuMemberPopupOwnProps

export class PeergroupMenuMemberPopup extends Component<PeergroupMenuMemberPopupProps> {
  render () {
    const {
      member,
      corners, onBackButtonClick,
      hideTimeoutId, onHidePopup, onRegisterHideTimeout,
    } = this.props

    return (
      <SidebarPopup
        corners={ corners }
        hidePopupTimeoutId={ hideTimeoutId }
        onHidePopup={ onHidePopup }
        onRegisterHideTimeout={ onRegisterHideTimeout }
      >
        <SidebarPopupHeader
          title='You'
          left={
            !!onBackButtonClick && (
              <SidebarPopupBackButton onClick={ onBackButtonClick } />
            )
          }
          right={
            <NavigationLink to='settings' onClick={ onHidePopup }>
              <button className={ styles.toSettings } />
            </NavigationLink>
          }
        />
        <PeerDefinition
          isRange={ false }
          age={ member.age || DEFAULT_PROP_VALUE }
          income={ member.income ? shortenMoney(member.income) : DEFAULT_PROP_VALUE }
          location={ member.city ? getCityStateLabel(member.city) : DEFAULT_PROP_VALUE }
          area_type={ member.area_type ? formatAreaType(member.area_type) : DEFAULT_PROP_VALUE }
          creditscore={ member.creditscore || DEFAULT_PROP_VALUE }
          housing_type={ formatHousingType(member.housing_type) }
        />
      </SidebarPopup>
    )
  }
}
